import moment from "moment/min/moment-with-locales.min";

export const formatOpeninHours = (openHours) => {
	return (openHours?.filter(
			(item) => Array.isArray(item.intervals) && item.intervals.length > 0,
	)
			.map((item) => {
				return {
					day: moment(item.date).format("dddd Do MMMM"),
					openingTimes: item.intervals
							.map((interval) => {
								return (
										moment(interval.start, "HH:mm:ss").format("HH[h]mm") +
										" - " +
										moment(interval.end, "HH:mm:ss").format("HH[h]mm")
								);
							})
							.join(" / "),
				};
			})) || "";
};
